module.exports = __webpack_public_path__ + "static/media/CACAO_07.db2ada6c.png";